import { COHORTS, useCohort, useLoggedOut } from '@/components/user-context/helpers/cohorts';

import { ProductCollectionCurrentProductUser } from './product-collection-current-product-user';
import { ProductCollectionExistingUser } from './product-collection-existing-user';
import { ProductCollectionLoggedOut } from './product-collection-logged-out';
import { ProductCollectionNewUser } from './product-collection-new-user';
import { ProductCollectionUpliftEligibleUser } from './product-collection-uplift-eligible-user';

export const ProductCollectionSignup = () => {
	const cohort = useCohort();
	const loggedOut = useLoggedOut();

	if (loggedOut) {
		return <ProductCollectionLoggedOut />;
	}

	if (!cohort) {
		return null;
	}

	switch (cohort) {
		case COHORTS.MANAGED_USER:
		case COHORTS.WEEK_ONE_USER:
		case COHORTS.CURRENT_PRODUCT_USER:
			return <ProductCollectionCurrentProductUser />;
		case COHORTS.UPLIFT_ELIGIBLE_USER:
			return <ProductCollectionUpliftEligibleUser />;
		case COHORTS.NEW_USER:
			return <ProductCollectionNewUser />;
		default:
			return <ProductCollectionExistingUser />;
	}
};
